'use client';

import React from 'react';
import { useVersionCheck } from '~/hooks/useVersionCheck';
import { Button } from '~/components/ui/button';
import { Text } from '~/components/ui/text';
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card';
import { RefreshCw } from 'lucide-react';

export const VersionUpdatePopup = () => {
  const { shouldShowPopup, dismissPopup, refreshApp } = useVersionCheck();

  if (!shouldShowPopup) {
    return null;
  }

  return (
    <div className={`fixed inset-0 z-50 ${shouldShowPopup ? 'block' : 'hidden'}`}>
      <div className="flex-1 bg-black/50 justify-end items-end px-4 min-h-screen">
        <Card className="w-full max-w-sm mx-auto bg-white dark:bg-gray-800">
          <CardHeader className="pb-3">
            <CardTitle className="flex flex-row items-center gap-2">
              <Text variant="title" size="lg">Update Available</Text>
            </CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            <Text className="text-sm text-gray-600 dark:text-gray-300">
              A new version is available. Refresh to get the latest updates.
            </Text>

            <div className="flex flex-row gap-3">
              <Button onClick={refreshApp} className="flex-1" variant="default">
                <div className="flex flex-row items-center justify-center gap-2">
                  <RefreshCw size={16} className="text-white" />
                  <Text className="text-white font-medium">Refresh</Text>
                </div>
              </Button>

              <Button onClick={dismissPopup} variant="ghost" className="flex-1">
                <Text className="font-medium">Later</Text>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
